import { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import {
  initializeAuth,
  isAuthenticated,
  getUiSourceName,
  getPortalAccessToken,
} from "./services/authService";
import { usePortalConfig } from "./context/PortalConfigContext";

function App() {
  const { loadPortalConfig, portalConfig } = usePortalConfig();

  useEffect(() => {
    // Phase 2.5: Restore Axios auth headers and log portal token presence.
    // initializeAuth sets axios.defaults.headers.common["Authorization"]
    // from the stored authToken so every subsequent client-API call is authenticated.
    initializeAuth();

    if (!isAuthenticated()) return;

    // ui_source_name is the short portal-facing name ("bajaj" / "ergo").
    // The portal config API is keyed on this, not the backend canonical name.
    const uiSource = getUiSourceName();
    const portalToken = getPortalAccessToken();

    console.log(
      "[App] Session restored | ui source:", uiSource,
      "| portal token:", portalToken ? "present" : "absent",
    );

    if (uiSource && !portalConfig) {
      console.log("[App] Background-fetching portal config for:", uiSource);
      loadPortalConfig(uiSource).catch((err) =>
        console.warn("[App] Background portal config refresh failed:", err.message),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
